/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

export interface ReportPermissions {
  canEdit?: boolean;
  canSubmit?: boolean;
  canApprove?: boolean;
  canReject?: boolean;
  canReopen?: boolean;
  canDelete?: boolean;
}

export interface ReportActionsInput {
  status: string;
  permissions?: ReportPermissions | null;
}

export interface ReportActions {
  canSubmit: boolean;
  canApprove: boolean;
  canReject: boolean;
  canReopen: boolean;
  canDelete: boolean;
  canEditItems: boolean;
  submitLabelKey: string;
}

// Stessa logica di mobile/lib/screens/reports/report_actions.dart: i pulsanti
// seguono solo i permessi decisi dal server, la pagina non ne indovina nessuno.
export const reportActions = (detail: ReportActionsInput): ReportActions => {
  const p = detail.permissions ?? {};
  return {
    canSubmit: p.canSubmit === true,
    canApprove: p.canApprove === true,
    canReject: p.canReject === true,
    canReopen: p.canReopen === true,
    canDelete: p.canDelete === true,
    canEditItems: p.canEdit === true,
    submitLabelKey:
      detail.status === 'REJECTED'
        ? 'expensa.action_submit_again'
        : 'expensa.action_submit',
  };
};
